import { Css } from "@homebound/beam";
import { useRouteParams } from "src/hooks/useRouteParams";
import { PlanPackageTakeoffSideBar } from "src/routes/libraries/plan-package/takeoffs/PlanPackageTakeoffSideBar";
import { TakeoffsManagerProvider } from "src/routes/libraries/plan-package/takeoffs/TakeoffsManagerContext";
import { PlanPackageTakeoffParams } from "src/routes/routesDef";
import { SideNavLayoutRoute } from "src/routing/components/layouts/SideNavLayoutRoute";

/**
 * Plan package takeoffs SideNav chrome for the data router.
 *
 * Role: data router pathless layout. Mounts `TakeoffsManagerProvider` above the legacy `SideNavLayout`
 * (via `SideNavLayoutRoute`) so the sidebar and page outlet share store state.
 */
export function PlanPackageTakeoffSideNavLayout() {
  const { planPackageId, planPackageVersionId } = useRouteParams<PlanPackageTakeoffParams>();
  return (
    <TakeoffsManagerProvider planPackageId={planPackageId} versionId={planPackageVersionId}>
      <SideNavLayoutRoute
        sideNavProps={{ sideNavConfig: [], top: <PlanPackageTakeoffSideBar />, navWidth: 265 }}
        layoutProps={{ contentCss: Css.pb3.mr2.$ }}
      />
    </TakeoffsManagerProvider>
  );
}
